var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTenantsPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 6H11V11H6V13H11V18H13V13H18V11H13V6Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTenantsPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tenants_plus.23aa6daae9685e6e19603ce5f22a24b4.svg";